import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/signatureStore';
import type { SignatureStore } from '../store/schema/SignatureStore';

export default mutatorAction('setRoamingSignatureStore', (signatureStore: SignatureStore) => {
    const roamingSignatureStore = getStore();
    roamingSignatureStore.legacySignature = signatureStore.legacySignature;
    roamingSignatureStore.roamingSignatureMap = signatureStore.roamingSignatureMap;
    roamingSignatureStore.defaultSignatureName = signatureStore.defaultSignatureName;
    roamingSignatureStore.defaultReplySignatureName = signatureStore.defaultReplySignatureName;
});
